export default "__VITE_ASSET__51f3e166__"